import React from 'react';
import { Theme, makeStyles, Typography, Link } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import { StyledText } from './StyledText';


const useStyles = makeStyles<Theme>((theme: Theme) => ({
  emailIcon: {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '50%'
  },
  emailText: {
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 12
    },
    fontSize: '20px',
    weight: '300',
    marginLeft: '10px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  }
}));

interface EmailLinkProps {
  email: string,
  clickable: boolean
  marginBottom?: string,
  marginTop?: string,
  marginLeft?: string,
  marginRight?: string
}

const EmailLink: React.FC<EmailLinkProps> = ({
  email,
  clickable,
  marginBottom,
  marginRight,
  marginLeft,
  marginTop
}) => {
  const styles = useStyles();
  return (
    <Box
      display='flex'
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      alignItems='center'
      overflow='hidden'
    >
      <EmailOutlinedIcon color='primary' />
      { clickable
        ? (
          <Link underline='always' color='secondary' href={`emailto:${email}`}>
            <StyledText className={styles.emailText}>{email || 'info@ventureraise.io'}</StyledText>
          </Link>
        )
        : <StyledText className={styles.emailText}>{email || 'info@ventureraise.io'}</StyledText> }
    </Box>
  );
};

export default EmailLink;
